import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'checkbox'];

  autocompleteCopy = null;

  onCheckboxChange(e) {
    if (
      (import.meta.env.APP_ENV === 'unknown' ||
        import.meta.env.APP_ENV === 'development' ||
        import.meta.env.APP_ENV === 'local') &&
      this.inputTarget.value === 'error'
    ) {
      throw new Error('This is a test error from input_password_controller.js');
    }

    const { checked } = e.target;
    if (checked) {
      this.autocompleteCopy = this.inputTarget.autocomplete;
      this.inputTarget.type = 'text';
      this.inputTarget.autocomplete = 'off';
    } else {
      this.inputTarget.type = 'password';
      this.inputTarget.autocomplete = this.autocompleteCopy;
    }
  }
}
